import {
    CatalogTransferImportError,
    CatalogTransferImportResult,
} from '@Entities/rightsholder/catalog-transfer-import-result'
import { z } from 'zod'

const catalogTransferImportErrorSchema: z.ZodType<CatalogTransferImportError> = z.object({
    rowNumber: z.string(),
    message: z.string(),
})

const catalogTransferImportResultSchema: z.ZodType<CatalogTransferImportResult> = z.object({
    success: z.boolean(),
    errors: z.array(catalogTransferImportErrorSchema),
})

const importStreamProgressMsgSchema = z.object({
    type: z.literal('progress'),
    processed: z.number(),
    errors: z.number(),
    ts: z.string(),
})

const importStreamErrorMsgSchema = z.object({
    type: z.literal('error'),
    payload: catalogTransferImportErrorSchema,
    ts: z.string(),
})

const importStreamCompleteMsgSchema = z.object({
    type: z.literal('complete'),
    success: z.boolean(),
    processed: z.number(),
    errors: z.number(),
    response: catalogTransferImportResultSchema,
    ts: z.string(),
})

const catalogTransferImportStreamMsgSchema = z.discriminatedUnion('type', [
    importStreamProgressMsgSchema,
    importStreamErrorMsgSchema,
    importStreamCompleteMsgSchema,
])

export type CatalogTransferImportStreamMsg = z.infer<typeof catalogTransferImportStreamMsgSchema>

export const parseCatalogTransferImportStreamMsg = (
    _event: string | undefined,
    msg: unknown
): CatalogTransferImportStreamMsg | undefined => {
    const parsed = catalogTransferImportStreamMsgSchema.safeParse(msg)
    return parsed.success ? parsed.data : undefined
}
